import { render } from "./DetailsSidePanel.vue?vue&type=template&id=138f7a3e"
import script from "./DetailsSidePanel.vue?vue&type=script&lang=js"
export * from "./DetailsSidePanel.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__